export const redirectGoto =
    window?.process?.env?.REDIRECT_GOTO ?? process.env.REDIRECT_GOTO;

export const SERVICE_AUTH_GATEWAY_URL =
    window?.process?.env?.SERVICE_AUTH_GATEWAY_URL ??
    process.env.SERVICE_AUTH_GATEWAY_URL;

export const IS_PROD =
    (window?.process?.env?.ENVIRONMENT ?? process.env.ENVIRONMENT) ===
    'production';
export const IS_NON_PROD =
    (window?.process?.env?.ENVIRONMENT ?? process.env.ENVIRONMENT) !==
    'production';

export const IS_BIA_MOCK_ENABLED =
    (window?.process?.env?.NODE_ENV ?? process.env.NODE_ENV) === 'development';

export const DEFAULT_BRAND = 'teladoc';
export const SMB_HY_BRAND = 'healthiestyou';
export const PREPROD_NODE_NAME = 'tdoctest';
export const PM_UNMASKED_NAME = 'pm-unmasked';
export const TEST_ENV_HOST = 'tdoctest.com';
export const MEAL_ID = 'meal_id';
export const MEAL_TYPE = 'meal_type';
export const FOOD_UI = 'food_ui';
export const VIDEO_URL = 'video_url';
export const CONSENT_AGREEMENT = 'consent_agreement_url';
export const SITEMAP = 'sitemap';
export const CACHED_DATA_MINUTES_TTL = 5;
export const MESSAGE_COUNTER_MINUTES_TTL = 10;
export const MESSAGE_COUNTER_EXPIRATION = 'message_counter_expiration';
export const DATA_LOAD_EXPIRATION = 'data_load_expiration';
export const INITIAL_DATA_LOAD = 'initial_data_load';
export const IS_TDOC_TOKEN_INVALID = 'is_tdoc_token_invalid';
export const ACCESS_TOKEN_PREV = 'access_token_prev';
export const MEMBER_AUTH_TOKEN_PREV = 'member_auth_token_prev';
export const MEMBER_ID_PREV = 'member_id_prev';
export const UN_LINKED_MEMBER = 'un_linked_member';
export const UN_LINKED_MEMBER_EXPIRATION = 'un_linked_member_expiration';
export const SEND_MESSAGE_ONCE = 'send-message-once';
export const ACCESS_TOKEN_TTL = 'acess_token_ttl';
export const EXPIRATION_TIME = 'expiration_time';
export const MEMBER_ID = 'member_id';
export const BUNDLE_IDENTIFIER = 'bundle_identifier';
export const BRAND_COLOR = 'brand_color';
export const TDOC_AUTH_TOKEN = 'member_auth_token';
export const MEMBER_ACTION_ID = 'member_action_id';
export const MEMBER_ACTION_ID_SESSION = 'member_action_id_session';
export const MY_REFRESH_COOKIE = 'my_refreshToken';
export const ACCESS_TOKEN_COOKIE = 'access_token';
export const REFRESH_TOKEN_COOKIE = 'refresh_token';
export const USER_LOCALE_COOKIE = 'user_preferred_language';
export const FOOD_TOUR_KEY = 'has-seen-food-tour';
export const NEXT_COACHING_SESSION = 'next-coaching-session';
export const COACH_SESSION = 'coach-session';
export const HOME = 'home';
export const IMPERSONATION = 'impersonation';
export const ACHIEVED_WEIGHT_COOKIE = 'has-seen-achieved-weight';
export const HF_RETAKE_ALERT_ID = 'retake-alert-id';
export const PIWIK_ENABLED = 'piwik-enabled';
export const NEXT_GEN_WEIGHT_DEVICE = 'wm2000';
export const COUNTRY_CODES = {
    CANADA: 'CA',
};
export const AUTHENTICATION = 'authentication';
export const HF_RETAKE_REACHOUT_NOT_NEEDED_KEY =
    'has-seen-retake-reachout-not-needed-card';
export const HF_RETAKE_LINK_TIMED_OUT_KEY = 'has-seen-retake-link-timeout';
export const MEMBER_SUPPORT_EMAIL = 'membersupport@livongo.com';
export const ONEAPP_SUPPORT_EMAIL = 'membersupport@teladochealth.com';
export const TWILIO_SMS_PHONE_NUMBER = '844-981-4079';
export const RAV_PATHS = [
    '/consult',
    '/health-info/',
    '/expert_opinion',
    '/find_best_doctor',
    '/information/tobacco_cessation',
];
export const TRIGGER_MESSAGE_COUNTER = [
    '/consult/new#ConsultationSuccess ',
    '/cancel#success',
    '/message-center/',
];
export const ALLOWED_BUNDLE_IDENTIFIERS = [
    'com.teladoc',
    'com.teladoc.members.canada',
    'com.healthiestyou',
    'com.clnonsso',
    'com.clsso',
];
export const HEALTHIESTYOU_BUNDLE_IDENTIFIER = 'com.healthiestyou';
export const MEMBER_COMMUNICATION_POLICY = {
    'en-US':
        'https://content.livongo.com/docs/Livongo_Member_Communication_Policy.pdf',
    'es-US':
        'https://content.livongo.com/docs/Livongo_Member_Communication_Policy.pdf',
    // TODO: update to Spanish Member Communication Policy once it's translated
};
export const MEMBER_SUPPORT_URL = {
    'en-US': 'https://www.teladochealth.com/helpcenter',
    'es-US': 'https://www.teladochealth.com/es-us/helpcenter',
};
export const LIBRARY_URL = {
    'en-US': 'https://www.teladochealth.com/library',
    'es-US': 'https://www.teladochealth.com/es-us/library',
};
export const TERMS_OF_SERVICE_URL = {
    'en-US': 'https://www.teladochealth.com/legal/terms-of-service',
    'es-US': 'https://www.teladochealth.com/es-us/legal/terms-of-service',
};
export const PRIVACY_POLICY_URL = {
    'en-US': 'https://www.teladochealth.com/legal/privacy-policy',
    'es-US': 'https://www.teladochealth.com/es-us/legal/privacy-policy',
    'en-CA': 'https://www.teladochealth.ca/legal/privacy-policy',
    'fr-CA': 'https://www.teladochealth.ca/fr/legal/privacy-policy',
};
export const PRIVACY_PRACTICES_URL = {
    'en-US': 'https://www.teladochealth.com/legal/notice-of-privacy-practices',
    'es-US':
        'https://www.teladochealth.com/es-us/legal/notice-of-privacy-practices',
};
export const NON_DISCRIMINATION_URL = {
    'en-US': 'https://www.teladochealth.com/legal/notice-of-non-discrimination',
    'es-US':
        'https://www.teladochealth.com/es-us/legal/notice-of-non-discrimination',
};
export const CONSENT_AGREEMENT_URL = {
    'en-US': 'https://www.teladochealth.com/legal/informed-consent-agreement',
    'es-US':
        'https://www.teladochealth.com/es-us/legal/informed-consent-agreement',
};
export const COPA_PRIVACY_URL =
    'https://content.teladochealth.com/docs/childrens-online-privacy.html';
export const ARTICLES = {
    'en-US': {
        wm1000: 'https://www.teladochealth.com/helpcenter/article/how-to-use-your-teladoc-health-wm1000-weight-scale',
        wm1500: 'https://www.teladochealth.com/helpcenter/article/how-to-weigh-in-with-the-teladoc-health-wm1500-weight-scale',
    },
    'es-US': {
        wm1000: 'https://www.teladochealth.com/es-us/helpcenter/article/how-to-use-your-teladoc-health-wm1000-weight-scale',
        wm1500: 'https://www.teladochealth.com/es-us/helpcenter/article/how-to-weigh-in-with-the-teladoc-health-wm1500-weight-scale',
    },
};
export const BLOOD_GULCOSE_METER_URL = {
    'en-US':
        'https://www.teladochealth.com/helpcenter/article/how-to-check-your-blood-sugar-with-your-blood-glucose-meter',
    'es-US':
        'https://www.teladochealth.com/es-us/helpcenter/article/how-to-check-your-blood-sugar-with-your-blood-glucose-meter',
};
export const HEART_RATE_URL = {
    'en-US':
        'https://www.teladochealth.com/library/article/getting-to-know-your-heart-rate',
    'es-US':
        'https://www.teladochealth.com/es-us/library/article/getting-to-know-your-heart-rate',
};
export const A1C_GUIDE_URL = {
    'en-US':
        'https://www.teladochealth.com/library/article/your-guide-to-lowering-your-a1c',
    'es-US':
        'https://www.teladochealth.com/es-us/library/article/your-guide-to-lowering-your-a1c',
};
export const BP_GUIDE_URL = {
    'en-US':
        'https://www.teladochealth.com/library/article/understanding-and-managing-high-blood-pressure',
    'es-US':
        'https://www.teladochealth.com/es-us/library/article/understanding-and-managing-high-blood-pressure',
};
export const NAME_INPUT_PATTERN = "^(?![- '.]+$)[-0-9A-zÀ-ž '.]*$"; // https://regex101.com/r/1D9Myt/97
export const ADDRESS_INPUT_PATTERN = '[-.0-9A-zÀ-ž #]+';
export const EMAIL_INPUT_MAX_LENGTH = 100;
export const CONFETTI_COLORS = [
    '#0060FC',
    '#36D663',
    '#86D5DF',
    '#66B5F7',
    '#E80048',
    '#34A847',
    '#E47600',
    '#845EF7',
    '#149DB1',
];
export const PHONE_INPUT_PATTERN =
    '^[(]?([0-9]{3})[)]?([-. ])?([0-9]{3})([-. ])?([0-9]{4})$';
export const FORMAT_DATETIME_NO_TZ = "yyyy-MM-dd'T'HH:mm:ss";
export const REFERRER_REGEX = /^https:\/\/(\w*\.)*livongo\.com\//;
export const BANNER_LAUNCH_DATE = {month: 4, day: 15};
export const BANNER_EXPIRY_DATE = {month: 5, day: 30};
export const CARE_RECIPIENT_AGREEMENT_URL =
    window?.location?.hostname?.includes('teladocdr.com')
        ? 'https://member.teladocdr.com/terms/cr_agreement.html'
        : 'https://member.teladoc.com/terms/cr_agreement.html';
export const FAQ_URL = 'https://www.teladoc.com/faq/';
export const VIDEO_PATH = '/video';
export const REMINDER_ID = 'reminder';
export const CGM_ID = 'cgm';
export const BODY_COMPOSITION_ID = 'bodyComposition';
export const PROGRAM_MENU = 'program';
export const INBOX = 'inbox';
export const NAV_MENU = {
    Home: {
        id: 'home',
    },
    Programs: {
        id: 'programs',
    },
    ConditionManagementHome: {
        id: 'conditionManagementHome',
    },
    HealthInfo: {
        id: 'healthInfo',
    },
    Message: {
        id: 'messages',
    },
    MessageCenter: {
        id: 'messageCenter',
    },
    Account: {
        id: 'account',
    },
    Sitemap: {
        id: 'sitemap',
    },
    Language: {
        id: 'language',
    },
    CardiometabolicHealthInsights: {
        id: 'healthInsights',
    },
    HealthInsights: {
        id: 'healthInsights',
    },
    LanguageAccessibility: {
        id: 'languageAccessibility',
    },
    HealthInsightsDashboard: {
        id: 'healthInsightsDashboard',
    },
    HealthInsightsReport: {
        id: 'healthInsightsReport',
    },
    LanguageSwitcher: {
        id: 'languageSwitcher',
    },
    CareOptions: {
        id: 'careOptions',
    },
};
export const FOOTER_CONTENT_STATE = {
    TeleMed: {
        id: 'teleHealth',
    },
    MyStrength: {
        id: 'myStrength',
    },
    ConditionManagement: {
        id: 'conditionManagement',
    },
    PartnerPrograms: {
        id: 'partnerPrograms',
    },
};
export const BREAKPOINT_SIZE = {
    Large: 'lg',
    Medium: 'md',
    Small: 'sm',
};
export const CONDITION_MANAGEMENT = 'conditionManagement';
export const AVAILABLE_PROGRAMS = 'availablePrograms';
export const MENTAL_HEALTH = 'mentalHealth';
export const PARTNER_PROGRAMS = 'partnerPrograms';
export const A1C_REPORT = 'a1c-report';
export const CHOLESTEROL_REPORT = 'cholesterol-report';
export const A1C_CHOLESTEROL_COMBINED_REPORT =
    'a1c-cholesterol-combined-report';
export const CARDIOMETABOLIC_LAB_KIT_FORM = 'cardiometabolic-lab-kit-form';
export const SELF_REPORT_SCREEN = [
    A1C_REPORT,
    CHOLESTEROL_REPORT,
    A1C_CHOLESTEROL_COMBINED_REPORT,
    CARDIOMETABOLIC_LAB_KIT_FORM,
];
export const NUTRITION = 'Nutrition';
export const WEIGHT_MANAGEMENT = 'WeightManagement';
export const HYPERTENSION_MANAGEMENT = 'HypertensionManagement';
export const DIABETES_MANAGEMENT = 'DiabetesManagement';
export const BETTER_SLEEP = 'BetterSleepLogo';
export const AEM_PATH = '/library/article/';
export const RAV_PATH = '/consult/new';
export const CCM_SCREEN_PATH = '/condition-management/';
export const BACKARROW_PATHS = [
    'a1c-report',
    'cholesterol-report',
    'a1c-cholesterol-combined-report',
    'health-insights',
    'health-insights-report',
    'cardiometabolic-lab-kit-form',
    'all-tasks',
    'task-detail',
    'download-app',
    'start-glp1-journey',
    'care-guide-activation',
];
export const CARDIO_METABOLIC_CATEGORY_VARIANTS = {
    HIGH: 'success',
    LOW: 'warning',
    MODERATE: 'highlight',
    NO_DATA: 'disabled',
};

export const CARDIO_METABOLIC_CONTAINERS = {
    EXCELLING: 'excelling',
    IMPROVEMENTS: 'improvements',
};
export const MYSTRENGTH_GUIDE_MESSAGE_FLAG = 'isGuideMessages=true';
export const MYSTRENGTH_ONEAPP_FLAG = 'isOneApp=true';
export const MESSAGE_SERVICE_TYPES = {
    ChronicCare: 'chronicCare',
    MentalHealth: 'mentalHealth',
    CareTeam: 'careTeam',
};
export const INBOX_SERVICE_TYPES = {
    CareTeam: 'telemed',
    ChronicCare: 'chronicCare',
    MentalHealth: 'myStrength',
};
export const SIDEBAR_MENU = {
    Weight: 'weight',
    Coaching: 'coaching',
};
export const OFFERED_PROGRAMS = {
    PrimaryCarePlan: 'Primary Care plan',
    PrimaryCareTeam: 'Primary Care team',
    ExpertMedicalOpinion: 'Expert Medical Opinion cases',
    Telemed: 'Telemed',
    ConditionManagement: 'Condition Management',
    MentalHealth: 'Mental Health Support',
    PrimaryCareVitals: 'Primary Care vitals',
    PartnerPrograms: 'Partner Programs',
    MyMentalHealth: 'MYMENTALHEALTH',
};
export const NONSTANDARD_MENTAL_HEALTH_ROUTES = {
    Onboarding: 'onboarding',
    Reassessment: 'reassessment',
    Interstitial: 'interstitial',
    Login: 'login',
    Base: 'mentalHealthBase',
    WaitingRoomHash: '#WaitingRoom',
};
export const EVENT_PROPS = {
    Home: 'Home',
    Global: 'Global',
    Programs: 'Programs',
    PartnerPrograms: 'Partner Programs',
    HealthInfo: 'Health Info',
    Account: 'Account',
    Logo: 'logo',
    Messages: 'Messages',
    ProductLine: 'product_line',
    PrimaryCare: 'Primary Care',
    HealthInsightsReports: 'Your health insights',
    LanguageAccessibility: 'Language and accessibility',
    ExpertMedicalOpinion: 'Expert Medical Opinion',
    CareTeam: 'Care team',
    MentalHealthGuides: 'Mental Health guides',
    CCMCoaches: 'Condition Management coaches',
    CCM: 'Chronic Condition Management',
    ConditionManagement: 'Condition Management',
    MentalHealth: 'Mental Health',
    MentalHealthPlan: 'mental health plan',
    Profile: 'Profile',
    SecuritySignIn: 'Security and sign in',
    CommPreferences: 'Communication preferences',
    EmergencyContacts: 'Emergency contacts',
    Family: 'Family',
    BillingCoverage: 'Billing and coverage',
    GetHelp: 'Get help',
    SignOut: 'Sign out',
    PastTeleVisits: 'Past telehealth visits',
    TeleDocuments: 'Telehealth visit documents',
    MedicalHistory: 'Medical history',
    PrescriptionSavings: 'Prescription savings',
    PrimaryCarePlan: 'Primary Care plan',
    PrimaryCareTeam: 'Primary Care team',
    ExpertMedRequests: 'Expert Medical Opinion requests',
    Pharmacies: 'Pharmacies',
    ExternalProviders: 'External providers',
    Inbox: 'inbox',
    GetCare: 'Get care',
    CareOptions: 'Care options',
    HealthInsightsScreen: 'health_insights_screen_view',
    HealthInsights: 'health_insights',
    GreatJobArea: 'great_job_areas',
    FocusAreaHighPriority: 'focus_areas_high_priority',
    FocusAreaNoPriority: 'focus_areas_no_priority_tag',
    FocusAreaNoData: 'focus_areas_no_data_tag',
    HealthInsightsButton: 'health_insights_button_click',
    FocusAreaName: 'focus_area_name',
    FocusAreaTags: 'focus_area_tags',
    FocusAreaScreen: 'focus_area_screen_view',
    FocusArea: 'health_insights.type',
    FocusAreaButton: 'focus_area_button_click',
    Action: 'action',
    FocusAreaLink: 'focus_area_link_click',
    LinkText: 'link_text',
    None: 'none',
    EventProperties: 'Event Properties',
    BiometricDataCard: 'Biometric Data Card',
    Weight: 'Scale',
    BloodPressure: 'Blood Pressure',
    BloodSugar: 'Blood Sugar',
    Food: 'Food',
    NextSteps: 'Next steps',
    NextStepsCompleted: 'Next steps - completed',
    NextStepsPostponed: 'Next steps - postponed',
    DownloadiOS: 'Download on the App Store',
    DownloadAndroid: 'Get it on Google Play',
};
// Properties shared by every health-insights Amplitude event; spread into the
// call site's own props.
export const HEALTH_INSIGHTS_EVENT_PROPS = {
    category: EVENT_PROPS.HealthInsights,
    // eslint-disable-next-line camelcase
    product_line: EVENT_PROPS.Global,
};

export const CATEGORY_PROPS = {
    Home: 'homepage',
    DownloadApp: 'download app',
    Tasks: 'tasks',
    CareGuide: 'care guide',
};

export const AMPLI_EVENT_PROPS = {
    Widget: 'widget',
    CardClick: 'Card click',
};
// TODO CSS-1996: Refactor these variables to pull URLs from process.env
export const UCS_CDN_LOWER_URL = 'https://cdn.visitstaging.org';
export const UCS_CDN_PROD_URL = 'https://cdn.visitnow.org';
export const UCS_SERVICE_REGISTRY_LOWER_URL =
    'https://mfe-service-registry.visitstaging.org';
export const UCS_SERVICE_REGISTRY_PROD_URL =
    'https://mfe-service-registry.visitnow.org';

export const USER_GLP1_STATES = {
    INTRO: 'intro',
    TRACKER: 'tracker',
};

export const CGM_PATH = '/condition-management/cgm/overview';
export const START_TRACKING_BODY_COMPOSITION =
    'START_TRACKING_BODY_COMPOSITION';

export {default as EnvConfig} from './env';
